/// <reference path="../../app.d.ts"/>
/// <reference path="../../../../typings/jquery.d.ts"/>
/// <reference path="../../../../../shared/models/generated/SchadenmeldungSchadenmeldungResponseApi.d.ts"/>
/// <reference path="../../../../../shared/models/generated/SchadenmeldungSchadenmeldungKostenReponseApi.d.ts"/>

import { VesDamageApiService } from '../../../../../shared/services/VesDamageApiService';
import { AppModelAdapter } from "../models/AppModelAdapter";
import { AppApplicationModel } from "../models/AppApplicationModel";
import { UploadModel } from "../../../../../shared/models/view/Upload";
import { User } from '../../../../../shared/models/api/User/User';
import { ZusammenfassungStrukturApi } from '../../../../../shared/models/generated/SchadenmeldungZusammenfassungStrukturApi';


export class AppApiService extends VesDamageApiService {

	constructor(options: DamageDeclarationOhcOptions, user: User) {
		super(options, user);
	}

	public submit(formModel: AppApplicationModel, uploadModel: UploadModel, summaryModel: ZusammenfassungStrukturApi, user: User,
		successCallback: (data: ApiResponse<SchadenmeldungResponseApi>, textStatus?: JQuery.Ajax.SuccessTextStatus, jqhxr?: JQuery.jqXHR) => void,
		errorCallback: (jjqxhr?: JQuery.jqXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {

		const req = AppModelAdapter.getSchadenmeldungSchutzbriefRequestApi(formModel, uploadModel, summaryModel, user);

		this.submitDamageDeclaration(req.toRequestObject(), successCallback, errorCallback);
	}
}
